import * as Sentry from "@sentry/react";

const DSN = import.meta.env.VITE_SENTRY_DSN || "__SENTRY_DSN__";

if (btoa(DSN) !== "X19TRU5UUllfRFNOX18=") {
  Sentry.init({
    dsn: DSN,
    environment: "__ENV__",
    integrations: [Sentry.browserTracingIntegration()],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}
